import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Plan from './Plan';
import { getStatus } from '@utils/dashboard/processCommon';

const FavoritePlans = (props) => {
    const {
        type,
        favPlans,
        status,
        link,
        handleClick
    } = props;

    const processedFavPlans = favPlans.map(favPlan => (
        <div key={favPlan.planId}
            className="grid-row"
        >
            <div className="tablet:grid-col-5 pr-3">
                <Plan plan={favPlan} />
            </div>
            <div className="tablet:grid-col-4 pr-3">
                { getStatus(type, favPlan.planId, status, {}, 'false', favPlan.issuerName) }
            </div>
            { link &&
                <div className="tablet:grid-col-3">
                    <div className="text-underline">
                        <a href="#"
                            onClick={handleClick}
                        >
                            <FormattedMessage id={link}/>
                        </a>
                    </div>
                </div>
            }
        </div>
    ));
    return (
        <Fragment>
            {processedFavPlans}
        </Fragment>);
};

export default FavoritePlans;